import styled from 'styled-components'

/*
 * `states` maps a record's state value onto a semantic status name —
 * { draft: 'disabled', submitted: 'info' }. Anything not in theme.emotive
 * falls back to `disabled` rather than throwing.
 */
const tone = ($status, theme) => theme.emotive[$status] || theme.emotive.disabled

const Badge = styled.span`
    display: inline-block;
    padding: 0.25rem 0.65rem;
    border-radius: 0.375rem;
    font-size: 0.8rem;
    font-weight: 500;
    background-color: ${({ $status, theme }) => tone($status, theme).bg};
    color: ${({ $status, theme }) => tone($status, theme).color};
    border: 1px solid ${({ $status, theme }) => tone($status, theme).border};
`

const StateBadge = ({ value, states }) => {
    if (!value) return null
    const label = value.charAt(0).toUpperCase() + value.slice(1)

    return <Badge $status={states?.[value] || 'disabled'}>{label}</Badge>
}

export default StateBadge
